import { useContext } from "react";
import { Link } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import ContextProduct from "../../context/contextproduct/ContextProduct";

const CartDropDown = ({ onClose }) => {
  const { cart, removeFromCart } = useContext(ContextProduct);

  const total = cart
    .reduce((acc, item) => acc + item.price * item.quantity, 0)
    .toFixed(2);

  return (
    <div className="cart-drop" role="dialog" aria-label="Cart preview">
      <div className="cart-drop__head">
        <h3>Your cart</h3>
        <span className="eyebrow">
          {cart.length} {cart.length === 1 ? "item" : "items"}
        </span>
      </div>

      {cart.length === 0 ? (
        <p className="cart-drop__empty">
          Nothing here yet.
          <br />
          Go find something good.
        </p>
      ) : (
        <>
          <div className="cart-drop__list">
            {cart.map((item) => (
              <div key={item.id} className="cart-drop__row">
                <img
                  src={item.image}
                  alt={item.title}
                  className="cart-drop__thumb"
                />
                <div style={{ minWidth: 0 }}>
                  <div className="cart-drop__name">{item.title}</div>
                  <div className="cart-drop__meta">
                    {item.quantity} &times; ${item.price.toFixed(2)}
                  </div>
                </div>
                <span className="cart-drop__price">
                  ${(item.price * item.quantity).toFixed(2)}
                </span>
                <button
                  type="button"
                  className="btn--danger"
                  onClick={() => removeFromCart(item.id)}
                  aria-label={`Remove ${item.title}`}
                >
                  <FiTrash2 size={15} />
                </button>
              </div>
            ))}
          </div>

          <div className="cart-drop__foot">
            <span className="cart-drop__total">Total ${total}</span>
            <Link
              to="/cart"
              className="btn btn--primary"
              onClick={onClose}
              style={{ fontSize: "0.8125rem", padding: "0.55rem 1rem" }}
            >
              View cart
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default CartDropDown;
